module.exports = __webpack_public_path__ + "img/loginlogo.60e5f557.png";